class LangPicker {
  constructor(element) {
    this.picker = element;
    this.button = element.querySelector('[data-element="button"]');
    this.dropdown = element.querySelector('[data-element="dropdown"]');
    this.submit = element.querySelector('[data-element="submit"]');
    this.close = element.querySelectorAll('[data-element="close"]');
  }

  init() {
    // Prebind functions for cleanup later
    this.onMouseover = this.onMouseover.bind(this);
    this.onMouseout = this.onMouseout.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);

    // Bind listeners that are dependent on screen size
    this.bindMatchMedia();

    // on touch screens these click events might need something to make it work on first tap
    this.button.addEventListener('click', this.onButtonClick);
    this.submit.addEventListener('click', this.onSubmitClick);
    this.close.forEach((element) => {
      element.addEventListener('click', this.onCloseClick);
    });
  }

  /**
   * Bind Event Listeners according to media query
   */
  bindMatchMedia() {
    const width = 1024;
    const widthMatch = window.matchMedia(`(min-width: ${width}px)`);

    widthMatch.addEventListener('change', (matchMedia) => {
      // If it matches then we are large screen
      if (matchMedia.matches) {
        this.picker.addEventListener('mouseover', this.onMouseover);
        this.picker.addEventListener('mouseout', this.onMouseout);
      } else {
        // remove mouse listeners because subnav expansion is triggered by click
        this.picker.removeEventListener('mouseover', this.onMouseover);
        this.picker.removeEventListener('mouseout', this.onMouseout);
      }
    });

    // Setup listeners for page load if needed
    if (window.innerWidth >= width) {
      this.picker.addEventListener('mouseover', this.onMouseover);
      this.picker.addEventListener('mouseout', this.onMouseout);
    }
  }

  onButtonClick() {
    if (this.picker.classList.contains('is-open')) {
      this.closeList();
    } else {
      this.openList();
    }
  }

  onMouseover() {
    this.openList();
  }

  onMouseout() {
    this.closeList();
  }

  onSubmitClick() {
    const input = this.picker.querySelector('[data-element="input"]:checked');

    if (window.location.href !== input.value) {
      window.location.href = input.value;
    }

    this.closeList();
  }

  onCloseClick() {
    this.closeList();
  }

  openList() {
    this.picker.classList.add('is-open');
    this.button.setAttribute('aria-expanded', true);
  }

  closeList() {
    this.picker.classList.remove('is-open');
    this.button.setAttribute('aria-expanded', false);
  }
}

const langPicker = {
  init() {
    const langPickerElement = document.querySelector('[data-module="lang-picker"]');

    if (langPickerElement) {
      const langPickerItem = new LangPicker(langPickerElement);
      langPickerItem.init();
    }
  },
};

export default langPicker;
